module.exports = __webpack_public_path__ + "img/menu.7b377f3f.svg";